<template>
	<div class="fullwidth bg_main">

		<div class="fullwidth padding15 ">
			<div class=" flex_row padding0 bg_fff radius10">
				<div v-for="(item,index) in menuArr"  v-bind:key="index" @click="getOrderListByState(item.state) "
					class="center flex1 height50 lineh50 ">
					<div :class="'size4 center '+(action==item.state?'color_red':'') ">{{item.name}}</div>
				</div>
			</div>
		</div>

		
		<div class="goods_box padding015">

			<div class="fullwidth " v-for="(item,index) in orderList"  v-bind:key="index">

				<div @click="toOrderDetail(item.id)" class="bg_fff radius10 marginb15 padding15 ">

					<div class="fullwidth">
						<div class="size4 paddingb10 flex_row">
							<div class="order-time-item">
								<img mode="widthFix" class="width18 height18 middle marginr5" src="@/assets/images/time.png" />
								<div class="inline middle">{{item.createTimeDisplay}}</div>
							</div>
							<span class="size4">{{item.stateDisplay}}</span>
						</div>


						<scroll-view class="overhide nowrap " scroll-x="true" bindscroll="scroll">
							<div v-for="(item2,index2) in item.goodsList" class="inline relative" :key="item2.id"
								:index="index2">
								<img :src="item2.img" class="width80 autoheight" mode="widthFix" />
								<div
									:class=" ' width80 overhide ellips size4 padding5 marginr5 ' +(index==selectedPriceIndex?'color_red':'') ">
									{{item2.name}}
								</div>
								<div
									class="absolute top0 right5 size5 nowrap width24 height24 center lineh24 bg_red color5 radius100">
									{{item2.currOrderCount}}
								</div>
							</div>
						</scroll-view>

					</div>
					<div class="line1"></div>
					<div class=" paddingb10 size4 total-price-item">
						<span class="total-num-item">数量{{item.count}}</span> 金额<span
							class="color_red">￥{{(item.goodsAmount+item.peisongAmount)}}</span>
					</div>


				</div>



				<div class="fullwidth right exe-item">


					<div v-if="item.isCanPay==1" @click="toPay0(item.id)" class="item_btn">
						支付</div>

					<div v-if="item.isCanDelete==1" @click="doDeleteOrder(item.id)" class="item_btn">
						取消</div>

					<div v-if="item.isCanEvaluate==1" @click="toEvaluate(item.id)" class="item_btn">
						评价</div>

					<div v-if="item.isCanSetDeliverSn==1" @click="showQrcodeForDeliver(item.id)" class="item_btn">
						门店取货码</div>

				</div>
				
			</div>




			<div v-if="isLoadFinished && orderList.length==0" class="empty center">
				<img class="width2 autoheight opacity5" mode="widthFix" src="@/assets/images/empty.png" />
			</div>



		</div>
		<uni-load-more :status="status" :icon-size="16" :content-text="contentText" />
	</div>
</template>

<script>
	import uniLoadMore from '@/components/uni-load-more/uni-load-more.vue';
	//


	export default {
		components: {
			uniLoadMore
		},
		data() {
			return {
				selectedPriceIndex:0,
				menuArr: [{
						name: "全部",
						state: ""
					},
					{
						name: "待付款",
						state: "wait_pay"
					},
					{
						name: "待发货",
						state: "wait_send"
					},
					{
						name: "待收货",
						state: "wait_receive"
					},
					{
						name: "待评价",
						state: "wait_pingjia"
					},
					// { name: "退款", state: 6 },
				],
				action: "", //查询订单类型参数，对应上述menuArr:state
				user: {},

				isLoadFinished: false,
				//------------------
				banner: {},
				orderList: [],
				page: 1,
				totalPage: 0,
				last_id: '',
				reload: false,
				status: 'more',
				adpid: '',
				contentText: {
					contentdown: '上拉加载更多',
					contentrefresh: '加载中',
					contentnomore: '没有更多'
				}
			};
		},
		created() {

			var options=this.$route.query || {};
			this.action = options.action;
			//this.getAdvList();
			this.page = 1;
			this.getList();
		},
		onPullDownRefresh() {
			this.reload = true;
			this.last_id = '';
			//this.getAdvList();
			this.page = 1;
			this.getList();
			// uni.stopPullDownRefresh();
		},
		onReachBottom() {
			this.status = this.page >= this.totalPage ? "nomore" : 'more';
			if (this.page < this.totalPage) {
				this.page++;
				this.getList();
			}
		},
		methods: {

			getOrderListByState(action) {
				this.isLoadFinished = false;
				this.action = action;
				this.getList({
					mohuState: action
				});
			},

			/**
			 * 查询订单
			 */
			getList: function(params) {
				console.log("订单列表");
				var that = this;
				if (typeof params == "undefined" || params == null) params = {};
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (!user || typeof user.id == "undefined") {
					alert( '请先登录' );
					return false;
				}
				if (typeof params.mohuState == "undefined") params.mohuState = that.action;
				if (params.state == 0) params.state = "";
				//params.mid = user.id;//查询我的订单
				params.page = that.page;
				params.queryFlag = that.queryFlag;
				this.$axios.request({
						url: window.$config.url.getOrderList,
						data: params
					})
					.then(res => {
						console.log(res.data)
						that.isLoadFinished = true;
						// uni.stopPullDownRefresh();
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							var orderList = res.data.list;
							orderList = that.fitData(orderList);
							if (params.page > 1) {
								orderList = that.orderList.concat(orderList);
							}
							that.totalPage = res.data.totalPage;
							that.orderList = orderList;
							if (orderList == null || orderList.length == 0) {
								alert( '没有订单' );
							}
						}
					})
					.catch(res => {
						// uni.stopPullDownRefresh();
						console.log(res);
					});

			},

			fitData(orderList) {
				if (orderList == null) return orderList;
				for (var i = 0; i < orderList.length; i++) {

					orderList[i].goodsList = JSON.parse(orderList[i].goodsListJson);
				}
				return orderList;
			},



			// sendMsgToWorker: function(e) {
			// 	console.log("提醒接单");

			// 	var that = this;
			// 	var user = window.$utils.uniapi.getStorageSync("user") || {};
			// 	if (!user || typeof user.id == "undefined") {
			// 		alert('请先登录' );
			// 		return false;
			// 	}
			// 	var params = {
			// 		mid: user.id,
			// 		type: "1",
			// 		order_id: e.target.dataset.id,

			// 	};

			// 	var url = config.urls.sendMsg;
			// 	params.sign = window.$utils.sign(window.$utils.getApiPath(url), params);
			// 	alert( '请稍等' )
			// 	const requestTask = uni.request({
			// 		url: url, //接口地址
			// 		data: params,
			// 		//header: {'content-type': 'application/json'},
			// 		success(res) {
			// 			// uni.hideLoading();
			// 			console.log(res.data)
			// 			if (res.data.code == "1000") {
			// 				alert('已提醒' )
			// 			}
			// 		},
			// 		fail: function(res) {
			// 			// uni.hideLoading();
			// 		}
			// 	})
			// },


			



			doDeleteOrder: function(id) {
				console.log("取消订单");

				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (!user || typeof user.id == "undefined") {
					alert('请先登录' );
					return false;
				}
				var params = {
					mid: user.id,
					id: id,

				};
				alert('请稍等' )
				this.$axios.request({
						url: window.$config.url.deleteOrder,
						data: params
					})
					.then(res => {
						window.$utils.uniapi.stopPullDownRefresh();
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							that.getOrderList();
						} else if (!!res.msg == true) {
							alert( res.msg );
						} else {
							alert( "不成功" );
						}
					})
					.catch(err=>{
						console.log("err",err );
					});

			},



			showWorkerPosition: function(e) {
				console.log("显示位置");

				this.$router.push({path:"/position_position",query:{mid:e.target.dataset.worker}}); 
			},

			toPay0(e) {
				console.log(e);
				var that = this;

				var id = e.currentTarget.dataset.id;
				this.$router.push({path:"/order_confirm",query:{id:id}}); 

			},

			//去支付（同步pages/order_list/order_list修改）
			toPay: function(id) {

				console.log("获取统一支付数据");
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (!user || typeof user.id == "undefined") {
					alert( '请先登录' );
					return false;
				}
				var params = {
					mid: user.id,
					id: id,
				};

				
				alert( '请稍等' )
				this.$axios.request({
						url: window.$config.url.getWxPayParams,
						data: params
					})
					.then(res => {
						window.$utils.uniapi.stopPullDownRefresh();
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							var resParams = res.data.data;
							//resParams = { "appId": "wxd678efh567hg6787", "nonceStr": "5K8264ILTKCH16CQ2502SI8ZNMTM67VS", "package": "prepay_id=wx2017033010242291fcfe0db70013231072", "signType": "MD5", "timestamp": 1560840662, "paySign": " 22D9B4E54AB1950F51E0649E8810ACD6"};
							// uni.requestPayment({
							// 	'timeStamp': resParams.timeStamp + "",
							// 	'nonceStr': resParams.nonceStr,
							// 	'package': resParams.package,
							// 	'signType': resParams.signType,
							// 	'paySign': resParams.paySign,
							// 	'success': function(res) {
							// 		console.log(res);
							// 		alert( '支付成功' );
							// 	},
							// 	'fail': function(res) {
							// 		console.log(res);
							// 		alert( '不成功' );
							// 	},
							// 	'complete': function(res) {
							// 		console.log(res);
							// 		this.$router.push({path:"/order_list",query:{}});  
							// 	}
							// });
						} else if (!!res.msg == true) {
							alert( res.msg );
						} else {
							alert( "不成功" );
						}
					})
					.catch(err=>{
						console.log("err",err );
					});
				
			},




			toOrderDetail: function(id) {
				//如未支付跳转支付
				// for (var i = 0; i < this.orderList.length; i++) {
				// 	if (this.orderList[i].id == id && this.orderList[i].isCanPay == 1) {
				// 		this.$router.push({path:"/order_confirm",query:{id:id}});
				// 		return;
				// 	}
				// }
				this.$router.push({path:"/order_confirm",query:{id:id}});

			},



			toEvaluate: function(e) {
				var that = this;
				var id = e.currentTarget.dataset.id;
				this.$router.push({path:"/order_evaluate",query:{id:id}});
			},
		}
	};
</script>

<style scoped>
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}

	.uni-media-list-logo {
		width: 90px;
		height: 70px;
	}

	.uni-media-list-body {
		height: auto;
		justify-content: space-around;
	}

	.uni-media-list-text-top {
		height: 37px;
		font-size: 14px;
		overflow: hidden;
	}

	.uni-media-list-text-bottom {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/views/order/list.vue